import {css} from 'lit';
export const styles = css`:host{display:block}[hidden]{display:none!important}`;
export default styles;
